import { getCookie, setCookie } from 'cookies-next';
import { NextRequest, NextResponse } from 'next/server';

const cookieKeys = {
  subscriptions: 'sb',
};

const subscriptionCookieSplitter = '~';
const getSubscriptionCookieCode = (subscriptionCode: string) =>
  `${subscriptionCookieSplitter}${subscriptionCode}${subscriptionCookieSplitter}`;

const getSubscriptionCookie = (req?: NextRequest, res?: NextResponse) => {
  return getCookie(cookieKeys.subscriptions, { req, res });
};

export const setSubscriptionCookie = (
  subscriptionCode: string,
  req?: NextRequest,
  res?: NextResponse,
) => {
  const code = getSubscriptionCookieCode(subscriptionCode);
  let subscriptionCodes = getSubscriptionCookie(req, res);

  if (!subscriptionCodes) {
    subscriptionCodes = code;
  } else if (!subscriptionCodes.includes(code)) {
    subscriptionCodes += `${subscriptionCode}${subscriptionCookieSplitter}`;
  }

  setCookie(cookieKeys.subscriptions, subscriptionCodes, {
    secure: true,
    req,
    res,
  });
};

export const isCodeInSubscriptionCookie = (
  subscriptionCode: string,
  req?: NextRequest,
  res?: NextResponse,
) => {
  const subscriptionCookie = getSubscriptionCookie(req, res);
  if (!subscriptionCookie) {
    return false;
  }

  const code = getSubscriptionCookieCode(subscriptionCode);
  return subscriptionCookie.includes(code);
};
